export default __webpack_public_path__ + "static/media/My_car_website_images-5_3.5399135c.webp";